export const P0003605ConsigneRegulationRxEnum = [
  { ref: 350, label: '350 mV' },
  { ref: 360, label: '360 mV' },
  { ref: 370, label: '370 mV' },
  { ref: 380, label: '380 mV' },
  { ref: 390, label: '390 mV' },
  { ref: 400, label: '400 mV' },
  { ref: 410, label: '410 mV' },
  { ref: 420, label: '420 mV' },
  { ref: 430, label: '430 mV' },
  { ref: 440, label: '440 mV' },
  { ref: 450, label: '450 mV' },
  { ref: 460, label: '460 mV' },
  { ref: 470, label: '470 mV' },
  { ref: 480, label: '480 mV' },
  { ref: 490, label: '490 mV' },
  { ref: 500, label: '500 mV' },
  { ref: 510, label: '510 mV' },
  { ref: 520, label: '520 mV' },
  { ref: 530, label: '530 mV' },
  { ref: 540, label: '540 mV' },
  { ref: 550, label: '550 mV' },
  { ref: 560, label: '560 mV' },
  { ref: 570, label: '570 mV' },
  { ref: 580, label: '580 mV' },
  { ref: 590, label: '590 mV' },
  { ref: 600, label: '600 mV' },
  { ref: 610, label: '610 mV' },
  { ref: 620, label: '620 mV' },
  { ref: 630, label: '630 mV' },
  { ref: 640, label: '640 mV' },
  { ref: 650, label: '650 mV' },
  { ref: 660, label: '660 mV' },
  { ref: 670, label: '670 mV' },
  { ref: 680, label: '680 mV' },
  { ref: 690, label: '690 mV' },
  { ref: 700, label: '700 mV' },
  { ref: 710, label: '710 mV' },
  { ref: 720, label: '720 mV' },
  { ref: 730, label: '730 mV' },
  { ref: 740, label: '740 mV' },
  { ref: 750, label: '750 mV' },
  { ref: 760, label: '760 mV' },
  { ref: 770, label: '770 mV' },
  { ref: 780, label: '780 mV' },
  { ref: 790, label: '790 mV' },
  { ref: 800, label: '800 mV' },
  { ref: 810, label: '810 mV' },
  { ref: 820, label: '820 mV' },
  { ref: 830, label: '830 mV' },
  { ref: 840, label: '840 mV' },
  { ref: 850, label: '850 mV' },
  { ref: 860, label: '860 mV' },
  { ref: 870, label: '870 mV' },
  { ref: 880, label: '880 mV' },
  { ref: 890, label: '890 mV' },
  { ref: 900, label: '900 mV' },
  { ref: 910, label: '910 mV' },
  { ref: 920, label: '920 mV' },
  { ref: 930, label: '930 mV' },
  { ref: 940, label: '940 mV' },
  { ref: 950, label: '950 mV' },
];
